var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type == 1
      ? _c("div", { staticClass: "slide ad1" }, [
          _c("div", { staticClass: "bd" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "li",
                  {
                    style: {
                      display: _vm.show == index ? "block" : "none",
                      opacity: _vm.show == index ? _vm.swiperOpacity : 0
                    }
                  },
                  [
                    _c("a", { attrs: { href: item.url, target: "_blank" } }, [
                      _c("img", { attrs: { src: item.images[0].url } })
                    ])
                  ]
                )
              })
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "hd" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "li",
                  { staticClass: "elip", class: { on: _vm.show == index } },
                  [_vm._v(_vm._s(item.title))]
                )
              })
            )
          ]),
          _vm._v(" "),
          _c("a", {
            staticClass: "prev",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                _vm.prev()
              }
            }
          }),
          _vm._v(" "),
          _c("a", {
            staticClass: "next",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                _vm.next()
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 2
      ? _c("div", { staticClass: "slide ad1" }, [
          _c("div", { staticClass: "bd" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "li",
                  {
                    style: {
                      display: _vm.show == index ? "block" : "none",
                      opacity: _vm.show == index ? _vm.swiperOpacity : 0
                    }
                  },
                  [_c("img", { attrs: { src: item.path } })]
                )
              })
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "hd" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c("li", { class: { on: _vm.show == index } }, [
                  _vm._v(_vm._s(item.miaoshu))
                ])
              })
            )
          ]),
          _vm._v(" "),
          _c("a", {
            staticClass: "prev",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                _vm.prev()
              }
            }
          }),
          _vm._v(" "),
          _c("a", {
            staticClass: "next",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                _vm.next()
              }
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5b8e5b1b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b8e5b1b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/swiper/swiper.vue
// module id = null
// module chunks = 